import type { ReactNode } from 'react'

import { lighten } from 'polished'
import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
	label: ReactNode
}

export const solidStyling = css<Props>`
	display: block;
	color: ${helpers.color.textContrast};
	background-color: ${({ type = 'primary', theme }) => theme.color[type]};
	-webkit-font-smoothing: antialiased;
	font-weight: ${helpers.font.weight.medium};
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.large};
	line-height: ${helpers.font.size.large};
	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 12px;
	min-width: 140px;
	height: 40px;
	padding: 9px 30px;
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;

	&:is(:focus-visible, :hover) {
		background-color: ${({ type = 'primary', theme }) => lighten(0.1, theme.color[type])};
		text-decoration: none;
		color: ${helpers.color.textContrast};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}
`

export const Solid = styled(LinkBase).attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
